/* eslint-disable no-plusplus */

const warningsDisplayed = {
  dataLoader: false,
  dataMultiLoader: false,
};

const displayWarning = (warning, message) => {
  if (!warningsDisplayed[warning]) {
    // eslint-disable-next-line no-console
    console.error(message);
    warningsDisplayed[warning] = true;
  }
};

export function dataLoader(nodeId) {
  displayWarning(
    'dataLoader',
    '[Deprecation Notice]: Use of dataLoader (and loading data from the DOM) is deprecated.'
  );
  const dataLoaderElem = document.getElementById(nodeId);
  if (dataLoaderElem && dataLoaderElem.textContent.trim() !== '') {
    return JSON.parse(dataLoaderElem.textContent);
  }
  return {};
}

export function dataMultiLoader(className) {
  displayWarning(
    'dataMultiLoader',
    '[Deprecation Notice]: Use of dataMultiLoader (and loading data from the DOM) is deprecated.'
  );
  const dataLoaders = document.getElementsByClassName(className);
  const result = [];
  for (let i = 0; i < dataLoaders.length; i++) {
    if (dataLoaders[i].textContent.trim() !== '') {
      result.push(JSON.parse(dataLoaders[i].textContent));
    }
  }
  return result;
}
